// Shared avto.net filter data (brands, fuel types, body types, seller types).
// Used by both the cars table and the SMS board so the search structure matches.

export const FUEL_TYPES = {
  '201': 'bencin',
  '202': 'diesel',
  '205': 'hibridni pogon (vsi)',
  '2054': 'HEV - hibrid',
  '2056': 'PHEV - plugin hibrid',
  '207': 'e-pogon',
  '203': 'plin',
};

export const BODY_TYPES = {
  '19': 'Microcar',
  '12': 'Kombilimuzina',
  '11': 'Limuzina',
  '13': 'Karavan',
  '14': 'Enoprostorec',
  '15': 'SUV',
  '16': 'Coupe',
  '17': 'Cabrio',
  '18': 'Pick-up',
};

export const SELLER_TYPES = {
  Uporabnik: 'Zasebnik',
  Trgovec: 'Trgovec',
};

export const POPULAR_BRANDS = [
  'Audi', 'BMW', 'Citroën', 'Ford', 'Mercedes-Benz',
  'Opel', 'Peugeot', 'Renault', 'Škoda', 'Volkswagen',
];

export const decodeFuelType = (code) => FUEL_TYPES[code] || code;

// Enako kot mobilni app: iz cene izlusci stevilo in doda locila tisocic + €.
export const formatPrice = (priceStr) => {
  if (!priceStr && priceStr !== 0) return 'Cena ni navedena';
  const n = String(priceStr).replace(/[^\d]/g, '');
  if (!n) return String(priceStr);
  return `${parseInt(n, 10).toLocaleString('sl-SI')} €`;
};

export const ALL_BRANDS = [
  'Abarth', 'Aeolus', 'AEV', 'Aito', 'Aiways', 'Aixam', 'Alfa Romeo', 'Alpine',
  'Aro', 'Artega', 'Aston Martin', 'Audi', 'Austin', 'Autobianchi', 'BAIC',
  'Bentley', 'Bertone', 'BMW', 'Borgward', 'Brilliance', 'Bugatti', 'Buick',
  'BYD', 'Cadillac', 'Casalini', 'Caterham', 'Chatenet', 'Chevrolet', 'Chrysler',
  'Citroën', 'Cobra', 'Cupra', 'Dacia', 'Daewoo', 'DAF', 'Daihatsu', 'DFSK',
  'DKW', 'Dodge', 'Donkervoort', 'Dongfeng', 'DR', 'DS Automobiles', 'EV', 'EVO',
  'Ferrari', 'Fiat', 'Fisker', 'Ford', 'Forthing', 'Geely', 'Genesis', 'GMC',
  'Greatwall', 'Grecav', 'Hansa', 'Honda', 'Hongqi', 'Hummer', 'Hyundai',
  'Infiniti', 'Iso', 'Isuzu', 'Iveco', 'JAC', 'Jaguar', 'JBA', 'JDM', 'Jeep',
  'Kia', 'KG Mobility', 'KTM', 'Lada', 'Lamborghini', 'Lancia', 'Land Rover',
  'LandWind', 'Lexus', 'Leapmotor', 'Ligier', 'Lincoln', 'London Taxi', 'Lotus',
  'LuAZ', 'Lynk&Co', 'Mahindra', 'Maruti', 'Maserati', 'Maybach', 'Mazda',
  'McLaren', 'Mercedes-Benz', 'MG', 'Microcar', 'MINI', 'Mitsubishi', 'Morgan',
  'Moskvič', 'MPM Motors', 'Nissan', 'NSU', 'Oldsmobile', 'Opel', 'Peugeot',
  'Piaggio', 'Plymouth', 'Polestar', 'Pontiac', 'Porsche', 'Proton', 'Puch',
  'Renault', 'Replica', 'Rolls-Royce', 'Rosengart', 'Rover', 'Saab', 'Saturn',
  'SEAT', 'Seres', 'Shuanghuan', 'Simca', 'Singer', 'Smart', 'Spyker', 'SsangYong',
  'Subaru', 'Suzuki', 'Škoda', 'Talbot', 'Tata', 'Tavria', 'Tazzari', 'Tesla',
  'Tiger', 'Toyota', 'Trabant', 'Triumph', 'TVR', 'UAZ', 'Vauxhall', 'Venturi',
  'Volga', 'Volvo', 'Volkswagen', 'Voyah', 'Wartburg', 'Westfield', 'Wiesmann',
  'XEV', 'Xiaomi', 'Xpeng', 'Zastava', 'ZAZ', 'Zhidou',
];
